module.exports = __webpack_public_path__ + "static/media/email-icon.fbf8ae95.svg";